/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.moderation.getMigrationStatus'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  receiptPresent: /*#__PURE__*/ l.boolean(),
  status: /*#__PURE__*/ l.string<{
    knownValues: ['clean', 'legacy', 'migrating', 'failed']
  }>(),
  updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  listblocksDiscovered: /*#__PURE__*/ l.integer({ minimum: 0 }),
  convertedToPrivateMute: /*#__PURE__*/ l.integer({ minimum: 0 }),
  deleted: /*#__PURE__*/ l.integer({ minimum: 0 }),
  failed: /*#__PURE__*/ l.integer({ minimum: 0 }),
  remainingListblocks: /*#__PURE__*/ l.integer({ minimum: 0 }),
  attestationRequired: /*#__PURE__*/ l.boolean(),
  attestedListCount: /*#__PURE__*/ l.integer({ minimum: 0 }),
  attestationProviderDid: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
  error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 240 })),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns redacted migration status for the authenticated account. Fork-specific; not an AT Protocol standard. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
